var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h2',{staticClass:"display-1"},[_c('v-layout',{staticClass:"no-grow",attrs:{"column":!_vm.$vuetify.breakpoint.xs}},[_c('strong',{staticClass:"domain display-2 bold"},[_vm._v(_vm._s(_vm.domain))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }